import { useLoadedData } from "../../toolympus/hooks/useLoadedData"
import { Judge } from "../Public/useJudgeRegistration"

export const useJudgeContactList = () => {
    return useLoadedData<Judge[]>("/api/secretary/judge", []);
}
